import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { KioskEventRetrieve } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseKioskEventType {
  eventType: 'class' | 'appointment';
  eventId: string;
  refetchInterval: number;
}

function useKioskEvent({
  eventType,
  eventId,
  refetchInterval,
}: IUseKioskEventType): UseQueryResult<AxiosResponse<KioskEventRetrieve>> {
  const fetchKioskEvent = (): Promise<AxiosResponse<KioskEventRetrieve>> => {
    const params: UrlParams = { limit: '100', offset: '0' };

    if (eventType) {
      params.eventType = eventType;
    }

    return client.get(`events/${eventId}/kiosk-event/?${encodeUrlParams(params)}`);
  };

  return useQuery(['events', 'kiosk-event', eventId, eventType, refetchInterval], fetchKioskEvent, {
    enabled: !!eventType,
    refetchInterval,
  });
}

export default useKioskEvent;
